import { useCallback, useEffect, useState } from 'react';
import {
  MILLISECONDS_IN_SEC,
  SECONDS_IN_MIN,
} from '../utilities/constants/time';
import { AppointmentHasuraStatus } from '../app/my-appointments/const/appointment';
import { UpcomingAppointments } from './useGetUpcomingAppointment';

const joinableStatuses = [AppointmentHasuraStatus.Booked];
const SHOW_LINK_BEFORE_START_TIME = 30 * SECONDS_IN_MIN * MILLISECONDS_IN_SEC;

export function useFirstJoinableIndex(appointments: UpcomingAppointments[]) {
  const [joinableIndex, setJoinableIndex] = useState<number | null>(null);

  const checkJoinableIndex = useCallback(() => {
    const now = Date.now();

    const index = appointments.findIndex((appointment) => {
      const { date: startDate, end: endDate, appointmentStatus } = appointment;

      if (
        !joinableStatuses.includes(appointmentStatus as AppointmentHasuraStatus)
      ) {
        return false;
      }

      const start = new Date(startDate).getTime();
      const end = new Date(endDate || '').getTime();
      const timeDiff = start - now;

      return timeDiff <= SHOW_LINK_BEFORE_START_TIME && now < end;
    });

    setJoinableIndex(index !== -1 ? index : null);
  }, [appointments]);

  useEffect(() => {
    checkJoinableIndex();
    const interval = setInterval(checkJoinableIndex, MILLISECONDS_IN_SEC);

    return () => clearInterval(interval);
  }, [checkJoinableIndex]);

  return joinableIndex;
}
